import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import SecretManagerService from '../api/secretsManager';
import { secretManagerActions } from '../reducers/secret-manager';


function* getSecrets({ payload }: any): any {  
  const res = yield call(SecretManagerService.fetchSecrets, payload);  
  if (res.status === 'success') {    
    yield put(secretManagerActions.getSecretsResponse(res?.res));
  } else {
    yield put(secretManagerActions.getSecretsFailed(res?.code));
  }
}

function* addSecret({ payload }: any): any {  
  const res = yield call(SecretManagerService.addNewSecret, payload);
  if (res.status === 'success') {
    yield put(secretManagerActions.addSecretResponse(res?.code));
  } else {
    yield put(secretManagerActions.addSecretFailed(res?.code));
  }
}

function* updateSecret({ payload }: any): any {
  const res = yield call(SecretManagerService.updateSecrets, payload);
  if (res.status === 'success') {
    yield put(secretManagerActions.updateSecretResponse(res?.code));
  } else {
    yield put(secretManagerActions.updateSecretFailed(res?.code));
  }
}

function* deleteSecret({ payload }: any): any {
  const res = yield call(SecretManagerService.deleteSecrets, payload);
  if (res.status === 'success') {
    yield put(secretManagerActions.deleteSecretResponse(res?.code));
  } else {
    yield put(secretManagerActions.deleteSecretFailed(res?.code));
  }
}


function* getSecretTemplates({ payload }: any): any {
    const res = yield call(SecretManagerService.fetchTemplates, payload);
    if (res.status === 'success') {      
      yield put(secretManagerActions.getSecretTemplateResponse(res?.res));
    } else {
      yield put(secretManagerActions.getSecretTemplateFailed(res?.code));
    }
  }
  
  function* addSecretTemplate({ payload }: any): any {
    const res = yield call(SecretManagerService.addNewTemplate, payload);
    if (res.status === 'success') {
      yield put(secretManagerActions.addSecretTemplateResponse(res?.code));
    } else {
      yield put(secretManagerActions.addSecretTemplateFailed(res?.code));
    }
  }
  
  function* updateSecretTemplate({ payload }: any): any {
    const res = yield call(SecretManagerService.updateTemplate, payload);
    if (res.status === 'success') {
      yield put(secretManagerActions.updateSecretTemplateResponse(res?.code));
    } else {
      yield put(secretManagerActions.updateSecretTemplateFailed(res?.code));
    }
  }
  
  function* deleteSecretTemplate({ payload }: any): any {
    const res = yield call(SecretManagerService.deleteTemplate, payload);
    if (res.status === 'success') {
      yield put(secretManagerActions.deleteSecretTemplateResponse(res?.code));
    } else {
      yield put(secretManagerActions.deleteSecretTemplateFailed(res?.code));
    }
  }

  function* fetchSecretById({ payload }: any): any {
    const res = yield call(SecretManagerService.fetchSecretById, payload);
    if (res.status === 'success') {      
      yield put(secretManagerActions.fetchSecretByIdResponse(res));
    } else {
      yield put(secretManagerActions.fetchSecretByIdFailed(res?.code));
    }
  }

  
  

function* secretManagerSaga() {
  yield takeLatest('secretsManager/fetchSecretByIdRequest', fetchSecretById);
  yield takeLatest('secretsManager/getSecretsRequest', getSecrets);
  yield takeLatest('secretsManager/getSecretTemplateRequest', getSecretTemplates);

  yield takeLeading('secretsManager/addSecretRequest', addSecret);
  yield takeLeading('secretsManager/addSecretTemplateRequest', addSecretTemplate);

  yield takeLeading('secretsManager/updateSecretRequest', updateSecret);
  yield takeLeading('secretsManager/updateSecretTemplateRequest', updateSecretTemplate);

  yield takeLeading('secretsManager/deleteSecretRequest', deleteSecret);
  yield takeLeading('secretsManager/deleteSecretTemplateRequest', deleteSecretTemplate);
}

export default secretManagerSaga;
